if (!customElements.get('video-carousel')) {
  customElements.define('video-carousel', class VideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;
      this.slider = this.querySelector('.reel-carousel__swiper');
      if (!this.slider) return;
      this.videos = [...this.querySelectorAll('video')];
      this.total = this.querySelectorAll('.swiper-slide').length;
      this.counter = this.querySelector('.reel-carousel__counter b');
      this.progress = this.querySelector('.reel-carousel__progress span');
      this.labels = {
        play: this.dataset.playLabel || 'Play',
        pause: this.dataset.pauseLabel || 'Pause',
        mute: this.dataset.muteLabel || 'Mute video',
        unmute: this.dataset.unmuteLabel || 'Unmute video'
      };
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 'auto', spaceBetween: 14, speed: 650,
        loop: this.dataset.loop === 'true' && this.querySelectorAll('.swiper-slide').length > 3,
        grabCursor: true, watchSlidesProgress: true,
        keyboard: { enabled: true },
        navigation: { nextEl: this.querySelector('.reel-carousel__next'), prevEl: this.querySelector('.reel-carousel__prev') },
        breakpoints: { 750: { spaceBetween: 22 }, 1200: { spaceBetween: 28 } },
        on: { init: swiper => this.update(swiper), slideChange: swiper => this.update(swiper) }
      });
      this.addEventListener('click', event => this.handleClick(event));
      this.addEventListener('play', event => this.handlePlay(event), true);
      if (Shopify.designMode) this.editorHandler = event => this.selectBlock(event);
      if (this.editorHandler) document.addEventListener('shopify:block:select', this.editorHandler);
    }
    disconnectedCallback() {
      if (this.editorHandler) document.removeEventListener('shopify:block:select', this.editorHandler);
      if (this.swiper) this.swiper.destroy(true, true);
    }
    update(swiper) {
      this.videos.forEach(video => video.pause());
      const current = swiper.realIndex + 1;
      if (this.counter) this.counter.textContent = String(current).padStart(2, '0');
      if (this.progress) this.progress.style.transform = `scaleX(${current / Math.max(this.total, 1)})`;
      this.querySelectorAll('.reel-card__play').forEach(button => {
        const title = button.closest('.reel-card')?.getAttribute('aria-label') || '';
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', `${this.labels.play}: ${title}`);
      });
      if (this.dataset.autoplay === 'true') {
        const activeVideo = swiper.slides[swiper.activeIndex]?.querySelector('video');
        activeVideo?.play().catch(() => {});
      }
    }
    handleClick(event) {
      const play = event.target.closest('.reel-card__play');
      const sound = event.target.closest('.reel-card__sound');
      if (play) {
        const video = play.closest('.reel-card').querySelector('video');
        if (!video) return;
        video.paused ? video.play().catch(() => {}) : video.pause();
        play.setAttribute('aria-pressed', String(!video.paused));
        const title = play.closest('.reel-card')?.getAttribute('aria-label') || '';
        play.setAttribute('aria-label', `${video.paused ? this.labels.play : this.labels.pause}: ${title}`);
      }
      if (sound) {
        const video = sound.closest('.reel-card').querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', String(video.muted));
        sound.setAttribute('aria-label', video.muted ? this.labels.unmute : this.labels.mute);
      }
    }
    handlePlay(event) {
      if (event.target.tagName !== 'VIDEO') return;
      this.videos.filter(video => video !== event.target).forEach(video => video.pause());
      const button = event.target.closest('.reel-card')?.querySelector('.reel-card__play');
      if (button) button.setAttribute('aria-pressed', 'true');
    }
    selectBlock(event) {
      if (!this.contains(event.target)) return;
      const slide = event.target.closest('.swiper-slide');
      if (slide) this.swiper.slideToLoop([...slide.parentElement.children].indexOf(slide));
    }
  });
}
